<script setup lang="ts">
type Props = {
	svg: string
}

defineProps<Props>();
</script>

<template>
	<div
		class="grid-shape"
		v-html="svg"
	/>
</template>

<style lang="scss">
@import "@zyro-inc/site-modules/scss/mixins/site-engine-mobile";

.grid-shape {
	display: flex;
	width: 100%;
	height: var(--shape-height, 100%);
	color: var(--shape-color);

	svg {
		width: 100%;
		height: 100%;
		fill: var(--shape-color);
	}
}

@include site-engine-mobile {
	.grid-shape {
		height: var(--m-shape-height, 100%);
	}
}

// Tablet size
@media screen and (min-width: $media-mobile-editor) and (max-width: $media-mobile) {
	.grid-shape {
		height: var(--t-shape-height, 100%);
	}
}

// Small desktop
@media screen and (min-width: $media-mobile) and (max-width: $media-desktop-editor) {
	.grid-shape {
		height: var(--small-desktop-shape-height, 100%);
	}
}

</style>
